import config from '../../config/config';

export const SEARCH_UPDATE_INPUT = 'SEARCH/UPDATE_INPUT';

export const SEARCH_ALL_CLEAR = 'SEARCH/ALL_CLEAR';

export const SEARCH_ALL_LOAD = 'SEARCH/ALL_LOAD';
export const SEARCH_ALL_SUCCESS = 'SEARCH/ALL_SUCCESS';
export const SEARCH_ALL_FAILURE = 'SEARCH/ALL_FAILURE';

export function searchAllFailureActionCreator(error) {
    return {
        error,
        type: SEARCH_ALL_FAILURE
    };
}

export function searchAllSuccessActionCreator(results) {
    return {
        results,
        type: SEARCH_ALL_SUCCESS
    };
}

export function clearSearchAll() {
    return {
        type: SEARCH_ALL_CLEAR
    };
}

export function searchAll(query, merchantIds) {
    let queryParamsString = `?search=${query}`;
    if (merchantIds) {
        queryParamsString += `&merchantIds=${merchantIds}`;
    }

    return {
        failureActionTypeOrCreator: searchAllFailureActionCreator,
        fetchParams: {
            url: `${config.searchApiUrl}/all${queryParamsString}`
        },
        loadActionTypeOrCreator: SEARCH_ALL_LOAD,
        successActionTypeOrCreator: searchAllSuccessActionCreator
    };
}

export function selectFilter(history, filter, query = '') {
    const queryString = query ? `/${query.trim()}` : '';
    history.replace(`/search/${filter}${queryString}`);
}

export function selectCustomer(history, customer) {
    history.push(`/customer/${customer.id}`);
}

export function getCustomerLink(customer) {
    return `/customer/${customer.id}`;
}

export function getTransactionLink(transaction) {
    return `/transaction/${transaction.id}`;
}

export function getFailedPayoutBatch(batchRef) {
    return `/payout?limit=10&offset=0&payoutStatus=90&batchRef=${batchRef}`;
}

export function getPayoutBatchReference(batchRef, startDate, endDate) {
    return `/payout?limit=10&offset=0&batchRef=${batchRef}&startDate=${startDate}&endDate=${endDate}`;
}

export function getChargebackLink(chargebackId) {
    return `/chargeback/${chargebackId}`;
}

export function updateInputValue(inputValue) {
    return {
        inputValue,
        type: SEARCH_UPDATE_INPUT
    };
}

export function goToSearchRoute(history, value = '', filter = 'all') {
    if (value.trim()) {
        history.replace(`/search/${filter}/${value}`);
    } else {
        history.replace(`/search/${filter}`);
    }
}
